require('./brand-settings-template.html');

angular.module('bbl.module.brand-settings.controller', [])
  .controller('BrandSettingsController', [
    '$scope', '$window', '$http', 'Auth', 'Toast', 'company', 'permissions',
    brandSettingsController
  ]);

function brandSettingsController($scope, $window, $http, Auth, Toast, company, permissions) {
  $scope.MODEL = company;
  $scope.permission_level = permissions;

  $scope.triggerFileInput = function(){
    document.getElementById("brand-logo-input").click();
  };

  $scope.changeLogo = function(files){
    var fd = new $window.FormData();
    fd.append("file", files[0]);

    $http.post('/bridges/api/v1/company/upload-logo/', fd, {
      transformRequest: angular.identity,
      headers: {'Content-Type': undefined}
    }).then(function(data){
      $scope.MODEL.logo = data.data.url;
      Toast.notify("{{'Logo has been changed successfully'|translate}}");
    }).catch(function(){
      console.log('error');
    });
  };

  $scope.updateBrandSettings = function() {
    if (!$scope.MODEL.name) {
      return Toast.error("{{'Please complete the field'|translate}} {{'company name'|translate}}");
    }

    Auth.updateCompanyInfo($scope.MODEL).then(
      Toast.notify.bind(Toast, "{{'Brand settings has been updated successfully'|translate}}")
    );
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/brand-settings/brand-settings.controller.js
 ** module id = 385
 ** module chunks = 0
 **/